export default "Skab nemt jeres egen jægerstenalder-dragter af stof. I kan dekorere dragterne med ”magiske tegn” eller håndaftryk.";